/*
------------------------------------------------------------------
    Custom scrollbar
    https://kingsora.github.io/OverlayScrollbars/#!documentation
------------------------------------------------------------------
*/

import { 
    OverlayScrollbars, 
    ScrollbarsHidingPlugin, 
    SizeObserverPlugin, 
    ClickScrollPlugin 
} from '../../node_modules/overlayscrollbars/overlayscrollbars.esm.js';

export class CustomScrollbar {
    
    constructor() {
        this.init();
    }

    init() {
        if( jQuery('.custom-scrollbar').length ) {
            const osInstance = OverlayScrollbars(document.querySelector('.custom-scrollbar'), {
                paddingAbsolute: true,
                overflow: {
                    x: 'auto',
                    y: 'hidden'
                },
                scrollbars: {
                    theme: 'os-theme-isolatiberina',
                    autoHide: 'never',
                    visibility: 'visible',
                    clickScroll: true,
                    pointers: ['mouse', 'touch', 'pen'],
                }
            });
        }

        if( jQuery('#productColumn2 .product-gallery').length ) {
            const osInstance = OverlayScrollbars(document.querySelector('#productColumn2 .product-gallery'), {
                paddingAbsolute: true,
                overflow: {
                    x: 'auto',
                },
                scrollbars: {
                    theme: 'os-theme-isolatiberina',
                    autoHide: 'never',
                    //visibility: 'visible',
                    clickScroll: true,
                    pointers: ['mouse', 'touch', 'pen'],
                }
            });
        }
    }
}
